import { isStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withMyLists } from '../../../utils/MyListsContext';
import { WithUrl } from '../../../utils/WithUrl';
import DesktopAlert from './Desktop/DesktopAlert';
import MobileAlert from './Mobile/MobileAlert';
import { styles as style } from './MyListAlert.style';

const MyListsAlert = ({ deviceType, myLists, page, appCtx }) => {
  const labels = appCtx?.siteConfig?.textDictionary ?? {};
  const { addedLists = [], undo, alertType } = myLists || {};
  const { store, regionCode } = appCtx;
  const urlMyLists = `${WithUrl(
    'FULL_HOST',
    isStandalone({ store }) ? `${regionCode}_${store}` : regionCode,
    {},
    isStandalone({ store }) ? store : undefined
  )}/myaccount/myLists`;

  const l = {
    savedChanges: labels.MY_LISTS_SAVED_CHANGES || 'Se guardaron los cambios.',
    undo: labels.MY_LISTS_UNDO || 'Deshacer',
    checkList: labels.MY_LISTS_CHECK_LISTS || 'Revisar listas',
    hasBeenAdded: labels.MY_LISTS_ADDED_LIST_MESSAGE || 'Se agregó a:',
  };

  const onNavigateToMyLists = () => {
    const eventToDigitalData = new CustomEvent('DDXLPMyListsClick', {
      bubbles: true,
      detail: {
        payload: 1,
      },
    });
    window.dispatchEvent(eventToDigitalData);
  };

  const content = () => {
    return (
      <div>
        {alertType === 'warning' ? (
          <div className="my-lists-alert warning">
            {l.savedChanges}{' '}
            {undo && (
              <button type="button" className="link" onClick={undo}>
                {l.undo}
              </button>
            )}
          </div>
        ) : (
          <div className="my-lists-alert">
            {l.hasBeenAdded}{' '}
            {addedLists.map((e, i, a) => (
              <b key={e}>
                {e}
                {i !== a.length - 1 && ', '}
              </b>
            ))}
            .{' '}
            <a className="link" onClick={onNavigateToMyLists} href={urlMyLists}>
              {l.checkList}
            </a>
          </div>
        )}
        <style jsx>{style}</style>
      </div>
    );
  };
  return (
    addedLists.length > 0 && (
      <>
        {deviceType !== 'desktop' && <MobileAlert content={content} type={alertType} page={page} />}
        {deviceType === 'desktop' && <DesktopAlert content={content} type={alertType} />}
      </>
    )
  );
};

MyListsAlert.propTypes = {
  myLists: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  page: PropTypes.string,
  appCtx: PropTypes.object.isRequired,
};
MyListsAlert.defaultProps = {
  page: '',
};
export { MyListsAlert };
export default withMyLists(withApplicationContext(MyListsAlert));
